import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ["select", "competitor"]

  initialize() {
    this.showDefaultCompetitor()
  }

  onCompetitorSelected(evt) {
    this.showSelectedCompetitor()
  }

  showDefaultCompetitor() {
    this.showSelectedCompetitor()
  }

  showSelectedCompetitor() {
    if (this.hasSelectTarget) {
      const selectedCompetitor = this.selectTarget.value
      this.competitorTargets.forEach((competitor) => competitor.classList.add("hidden-xs", "hidden-sm", "-hide"))
      this.competitorTargets.
        filter(competitor => competitor.dataset.jsCompetitor === selectedCompetitor).
        forEach(competitor => competitor.classList.remove("hidden-xs", "hidden-sm", "-hide"))
    }
  }
}
